import { itamAiInsightsPreviewRoute } from '@jira/router-routes__itam-routes/src/itamAiInsightsPreviewRoute.tsx';
import { itamAiInsightsPreviewEntryPoint } from '@jira/spa-apps__itam-ai-insights-preview/src/itamAiInsightsPreviewEntryPoint.entrypoint.tsx';
import { verticalInstantiationResource } from '@jira/router-resources__itam/src/verticalInstantiationResource.tsx';
import { avsWorkspaceResource } from '@jira/router-resources__itam/src/avsWorkspaceResource.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { itamDashboardsSemanticModelResource } from '@jira/router-resources__viz-platform/src/itamDashboardsSemanticModelResource.tsx';
import { workspaceResource } from '@jira/servicedesk__insight-common-services-workspace-context/src/workspaceResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

const itamAiInsightsPreviewPageEntryPoint = createChromelessEntryPoint({
	main: itamAiInsightsPreviewEntryPoint,
});

export const itamAiInsightsPreviewRouteEntry: Route = createEntry(
	itamAiInsightsPreviewRoute,
	() => ({
		group: 'servicedesk',
		layout: chromelessLayout,
		entryPoint() {
			return fg('itam_ftw') ? itamAiInsightsPreviewPageEntryPoint : notFoundPageEntrypoint;
		},
		bifrost: {
			bifrostGroup: 'shell-only',
			enabled: true,
		},
		resources: [
			workspaceResource,
			verticalInstantiationResource,
			resourceWithCondition(() => fg('itam_ftw'), avsWorkspaceResource),
			resourceWithCondition(
				() => fg('platform_avp_enable_jsm_assets_metrics'),
				itamDashboardsSemanticModelResource,
			),
		],
	}),
);
